import { render, staticRenderFns } from "./Sales.vue?vue&type=template&id=2eed7513&scoped=true&"
import script from "./Sales.vue?vue&type=script&lang=js&"
export * from "./Sales.vue?vue&type=script&lang=js&"
import style0 from "./Sales.vue?vue&type=style&index=0&id=2eed7513&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eed7513",
  null
  
)

component.options.__file = "Sales.vue"
export default component.exports